export default "__VITE_PUBLIC_ASSET__304f2d9b__"